import { render, staticRenderFns } from "./teamNation.vue?vue&type=template&id=feae3478&scoped=true&lang=pug&"
import script from "./teamNation.vue?vue&type=script&lang=js&"
export * from "./teamNation.vue?vue&type=script&lang=js&"
import style0 from "./teamNation.vue?vue&type=style&index=0&id=feae3478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feae3478",
  null
  
)

export default component.exports